module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table":{"headers":{"openApplicationsFor":"Open applications for","jobPosition":"Job position","teammate":"Teammate"},"label":{"selectOwner":"Select owner"}}}}')
  delete Component.options._Ctor
}
